/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Compose_SuggestedInputs */



/**
* | output |
* | --- |
* | "Suggested from what you have already filled in" |
*
* @param {Uno_Compose_SuggestedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_compose_suggested = /** @type {((inputs?: Uno_Compose_SuggestedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Compose_SuggestedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschlag auf Basis Ihrer bisherigen Angaben")
	return /** @type {LocalizedString} */ ("Suggested from what you have already filled in")
});